export default "__VITE_ASSET__DYbp88BQ__"